import * as types from "./ordini.types.js";

const initialState = {
    data: [],
    loading: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.REQUEST_READ_ALL:
            state = {
                ...state,
                loading: true,
                data: []
            }
            break;
        case types.READ_ALL_ERROR: {
            state = {
                ...state,
                loading: false,
                data:  []
            }
            break
        }
        case types.READED_ALL:
            state = {
                ...state,
                data: action.payload,
                loading: false
            }
            break;
        case types.CREATED:
            state = {
                ...state,
                data: [
                    action.payload,
                    ...state.data
                ]
            }
            break;
        case types.CREATED_RECURRENT:
            state = {
                ...state,
                data: [
                    ...state.data,
                    ...action.payload
                ]
            }
            break;

        case types.DELETED: {
            let data = [...state.data];
            if (data) {
                for (let i = 0; i < data.length; i++)
                    if (data[i].id === action.payload.id) {
                        data.splice(i, 1);
                        break;
                    }
            }
            state = {
                ...state,
                data:data
            }
            break;
        }
        case types.UPDATED: {
            let data = [...state.data];
            if (data) {
                for (let i = 0; i < data.length; i++)
                    if (data[i].id === action.payload.id) {
                        data[i] = action.payload;
                        break;
                    }
            }
            state = {
                ...state,
                data:data
            }
            break;
        }
        case types.ORDER_ASSIGN:
            state = {
                ...state,
                assignOrder: action.payload,
            }
            break;
        case types.ORDER_CHANGED_STATE: {
            let data = [...state.data];
            if (data) {
                for (let i = 0; i < data.length; i++)
                    if (data[i].id === action.payload.id) {
                        data[i] = action.payload;
                        break;
                    }
            }
            state = {
                ...state,
                data:data
            }
            break;
        }
        default:
            break;
    }

    return state;
}

export default reducer;
